module.exports = __webpack_public_path__ + "static/media/roof-1.c11bb9fb.jpg";